import {Option} from "fp-ts/lib/Option";


export class ProfileDataBundle {
    readonly name: string;
    readonly surname: string;
    readonly bio: string;
    readonly image: string;
    readonly checkEmailNotificationsActivated: boolean;
    readonly emailContact: Option<string>;
    readonly emailNotifications: boolean;
    readonly videosActivated: boolean;
    readonly voiceActivated: boolean;
    readonly hideGroupCreationButton: boolean;


    constructor(name: string, surname: string, bio: string, image: string, checkEmailNotificationsActivated: boolean,
                emailContact: Option<string>, emailNotifications: boolean, videosActivated: boolean,
                voiceActivated: boolean, hideGroupCreationButton: boolean) {
        this.name = name;
        this.surname = surname;
        this.bio = bio;
        this.image = image;
        this.checkEmailNotificationsActivated = checkEmailNotificationsActivated;
        this.emailContact = emailContact;
        this.emailNotifications = emailNotifications;
        this.videosActivated = videosActivated;
        this.voiceActivated = voiceActivated;
        this.hideGroupCreationButton = hideGroupCreationButton;
    }
}
